export const freeGiftTrack = (active, gifts, freeShippingThreshold) => ({
  active,
  gifts: gifts?.sort((a, b) => a.threshold - b.threshold),
  freeShippingThreshold: Number(freeShippingThreshold),

  get progress() {
    const total = Alpine.store('cart').totalPrice / 100;
    if (total < this.freeShippingThreshold) {
      return {
        percentage: (total / this.freeShippingThreshold) * 50 + '%',
        nextItem: 'Shipping',
        remainder: (this.freeShippingThreshold - total)?.toFixed(2),
      };
    } else {
      const totalGifts = this.gifts.length;
      for (let i = 0; i < totalGifts; i++) {
        if (total < this.gifts[i]?.threshold) {
          const interval = 50 / totalGifts;
          const lower = 50 + (i / totalGifts) * 50;
          const intervalMoney = this.gifts[i]?.threshold - (this.gifts[i - 1]?.threshold || this.freeShippingThreshold);
          const progress = (total - (this.gifts[i - 1]?.threshold || this.freeShippingThreshold)) / intervalMoney;
          const percentage = (lower + interval * progress)?.toFixed(2);
          // console.log(i, lower, upper, interval, intervalMoney, progress, percentage);
          // return percentage + '%';
          return {
            percentage: percentage + '%',
            nextItem: this.gifts[i]?.name,
            remainder: (this.gifts[i]?.threshold - total)?.toFixed(2),
          };
        }
      }
    }

    return {
      percentage: '100%',
      nextItem: null,
      remainder: 0,
    };
  },

  get maxThreshold() {
    return Math.max(...this.gifts.map((gift) => gift.threshold));
  },
});

export const Cart = () => ({
  totalItems: 0,

  // Cart: Add Item
  addToCart(variant = {}, quantity = 1, options = {}) {
    // const cart = window.Rebuy?.Cart;
    // // Guards
    // if (!cart) {
    //   console.error('Rebuy not initialized yet');
    //   return;
    // }

    // if (!variant.id) {
    //   console.error('No variant object provided');
    //   return;
    // }

    // // Add quantity to Variant
    // variant['quantity'] = quantity;

    // // If the variant has options, add each key the variant object
    // if (options) {
    //   Object.keys(options).forEach((key) => {
    //     variant[key] = options[key];
    //   });
    // }

    // // Add to Rebuy Cart object
    // cart.addItem(variant);

    Alpine.store('cart').addVariant(variant.id, quantity);
  },

  // Cart: Toggle
  toggleCart() {
    const cart = window.Rebuy?.SmartCart;
    // Guard
    if (!cart) {
      console.error('Rebuy not initialized yet');
      return;
    }
    const isActive = document.documentElement.classList.contains('smart-cart--enabled');
    if (isActive) {
      cart.hide();
    } else {
      cart.show();
    }
  },

  init() {
    const updateCartQuantity = (event) => {
      const cart = event.detail.cart;
      const totalItems = cart.itemCount();
      this.totalItems = totalItems;
    };
    document.addEventListener('rebuy:cart.change', updateCartQuantity);
  },
});
